var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"$parallaxContainer",staticClass:"PastaParallaxWrapperCmp"},[_c('div',{ref:"$parallaxWrapper",staticClass:"wrapper"},[_c('div',{staticClass:"parallax-bg-left",style:({
        backgroundImage: ("url(" + (_vm.$context.staticRoot) + "project/img/parallax-fusillo.png)"),
      })}),_vm._t("default"),_c('div',{staticClass:"parallax-bg-right",style:({
        backgroundImage: ("url(" + (_vm.$context.staticRoot) + "project/img/parallax-rigatone.png)"),
      })})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }